import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Footer from "../layout/Footer";

class NotFound extends Component {
	render() {
		return (
			<div className="notfound">
				<div className="sd_header_section">
					<div class="sd_sub_container">
						<div class=" sd_not_found_header">
							<h2 class="uppercase">OH NO.</h2>
							<div class="sd_not_found_header_desc">
								<p>We can’t seem to find that page.</p>
							</div>
							<div className="nofound_content">
								<Link to="/"> <img src="/images/slider_arrow_left.svg" alt="" /> Back to Home </Link>
							</div>
						</div>
					</div>
				</div>       

				<Footer />
			</div>
		);
	}
}

export default NotFound;